import { useTranslation } from 'react-i18next';
import { Helmet } from 'react-helmet-async';
import { useParams } from 'react-router-dom';

function Legal() {
  const { t } = useTranslation('legal');
  const { lang } = useParams<{ lang: string }>();

  return (
    <>
      <Helmet>
        <title>Legal Information & Privacy Policy - ShiftPic</title>
        <meta name="description" content="Legal information, privacy policy, and terms of use for ShiftPic - the free online image converter. Learn about our data practices and user agreements." />
        <meta name="keywords" content="ShiftPic legal, privacy policy, terms of use, data protection, user agreement, image converter terms, GDPR compliance, data processing, privacy information, cookie policy, terms and conditions" />
        <link rel="canonical" href={`https://shiftpic.com/${lang || 'en'}/legal/`} />
        <meta property="og:title" content="Legal Information & Privacy Policy - ShiftPic" />
        <meta property="og:description" content="Legal information, privacy policy, and terms of use for ShiftPic - the free online image converter. Learn about our data practices and user agreements." />
        <meta property="og:type" content="website" />
        <meta property="og:url" content={`https://shiftpic.com/${lang || 'en'}/legal/`} />
        <meta property="og:image" content="https://shiftpic.com/og-image.jpg" />
        <meta property="og:image:width" content="1200" />
        <meta property="og:image:height" content="630" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Legal Information & Privacy Policy - ShiftPic" />
        <meta name="twitter:description" content="Legal information, privacy policy, and terms of use for ShiftPic - the free online image converter. Learn about our data practices and user agreements." />
        <meta name="twitter:image" content="https://shiftpic.com/og-image.jpg" />
      </Helmet>

      <div className="max-w-4xl mx-auto px-4 py-12">
          <div className="mt-8 mb-16">
            <h1>{t('title')}</h1>
            <p>{t('lastUpdated', { date: new Date().toLocaleDateString() })}</p>
          </div>
              
          <section className="mb-12" aria-labelledby="privacy-policy">  
            <h2 id="privacy-policy">{t('sections.privacy.title')}</h2>
            <p>{t('sections.privacy.description')}</p>
            <p>{t('sections.privacy.processing')}</p>
            
            <h3>{t('sections.privacy.analytics.title')}</h3>
            <p>{t('sections.privacy.analytics.description')}</p>
            <ul className="list-disc pl-6 mb-4">
              {(t('sections.privacy.analytics.items', { returnObjects: true }) as string[]).map((item, index) => (
                <li key={index}>{item}</li>
              ))}
            </ul>
            <p>{t('sections.privacy.analytics.anonymity')}</p>
            <p>{t('sections.privacy.analytics.cookies')}</p>
            <p>{t('sections.privacy.analytics.sharing')}</p>
          </section>
              
          <section className="mb-12" aria-labelledby="terms-of-use">
            <h2 id="terms-of-use">{t('sections.terms.title')}</h2>
            <p>{t('sections.terms.description')}</p>
            <p>{t('sections.terms.agreement')}</p>
            <p>{t('sections.terms.disclaimer')}</p>
            
            <h3>{t('sections.terms.contentResponsibility.title')}</h3>
            <p>{t('sections.terms.contentResponsibility.description')}</p>
            <ul className="list-disc pl-6 mb-4">
              {(t('sections.terms.contentResponsibility.items', { returnObjects: true }) as string[]).map((item, index) => (
                <li key={index}>{item}</li>
              ))}
            </ul>
            <p>{t('sections.terms.contentResponsibility.termination')}</p>
            <p>{t('sections.terms.contentResponsibility.updates')}</p>
          </section>
              
          <section className="mb-12" aria-labelledby="contact-information">  
            <h2 id="contact-information">{t('sections.contact.title')}</h2>
            <p>{t('sections.contact.description')}</p>
            <p>{t('sections.contact.email')}</p>
            <p>{t('sections.contact.response')}</p>
          </section>
        </div>
    </>
  );
}

export default Legal;